import React from "react"

import { colors } from "@/styles/colors"

import PortletWithSplitContent from "@/components/PortletWithSplitContent"
import { Typography } from "@material-ui/core"
import ColorUtil from "@/utils/ColorUtil"
import LetalkLogo from "@/components/SVGComponents/LetalkLogo"
import useCustomStyles from "@/styles/custom"

const ExpiredTokenPage: React.FC = () => {
	const customClasses = useCustomStyles()

	return (
		<PortletWithSplitContent
			title={{
				value: "Confirmação de login",
				logo: <LetalkLogo
					className={customClasses.logo}/>,
				...ColorUtil.getBackgroundAndContrastColor(colors.green[500]),
				textColor: colors.gray[0]
			}}
			body={{
				...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
			}}
		>
			<Typography
				align="center"
				variant="subtitle1"
			>
				Seu token de confirmação de e-mail expirou!
			</Typography>
		</PortletWithSplitContent>
	)
}

export default ExpiredTokenPage
